<div #wrapper class="search-wrapper">
    <div #expander class="expander">
        <label class="kk-visuallyhidden" for="search">{{ 'search.labels.default' | translateSafe }}</label>
        <button type="submit" class="icon icon-left">
            <span class="kk-visuallyhidden">{{ 'search.labels.default' | translateSafe }}</span>
            <app-svg-icon iconName="search"></app-svg-icon>
        </button>
        <input
            *ngIf="!(breakpointMinService.breakpoint$ | async)?.isTabletOrSmaller"
            [formControl]="searchInput"
            [name]="customFilterParams.searchQuery"
            [placeholder]="'search.placeholders.default' | translateSafe"
            type="text"
            autocomplete="off"
            (focus)="handleFocus()"
            (blur)="handleBlur()"
            size="10"
            id="search"
        />
        <input
            *ngIf="(breakpointMinService.breakpoint$ | async)?.isTabletOrSmaller"
            [formControl]="searchInput"
            [name]="customFilterParams.searchQuery"
            [placeholder]="'search.placeholders.default' | translateSafe"
            type="text"
            autocomplete="off"
            (focus)="handleFocusMobile()"
            (blur)="handleBlurMobile()"
            size="10"
            id="search"
        />
        <div
            class="spinner"
            *ngIf="
                (searchStateService.productSearchInProgress$ | async) ||
                    (searchStateService.contentSearchInProgress$ | async);
                else clearButton
            "
        >
            <app-loading-dots></app-loading-dots>
        </div>
        <div class="search-extra">
            <div class="search-extra__wrapper"></div>
        </div>
        <ng-template #clearButton>
            <button
                (click)="searchInput.setValue('')"
                type="button"
                class="icon clear-button kk-content-fade-in"
                *ngIf="searchInput.value.length"
            >
                <app-svg-icon iconName="close"></app-svg-icon>
            </button>
        </ng-template>
    </div>
</div>
